import { analySend } from '@chat/utils';
import { clickstage, faqchangeStatus, faqinit } from '@/redux/faq/action';
import { init, saveContact, selectgm } from '@/redux/im/action';
import store from '@/redux/index';
import { getformtoken, setloading, setuserinfo } from '@/redux/index/action';
import { IM_SAVE_CONTACT, IM_USER_INFO, InitServerImp } from '@/typings/global';
import { ImState } from '@/typings/reducer';
import { PAYLOAD_START_SESSION } from '@/typings/payload';
import { outline } from '@/helpers/online';

const { dispatch, getState } = store;
class InitServer implements InitServerImp {
    /** 激活界面 */
    private _active: () => void;

    /** 设置用户信息 */
    private _registerUserInfo: (info: any) => void;

    constructor() {
        this._active = () => {
            const {
                base_config: { faq_switch }
            } = getState().IndexReducer;
            IM.IMServer.iswakeup({ actived: 1 });
            faqchangeStatus(!!faq_switch)(dispatch);
        };
        this._registerUserInfo = (info) => {
            setuserinfo({
                guest: info.guest,
                user_nick: info.user_nick,
                user_head_img: info.user_head_img,
                user_contact: info.user_contact
            })(dispatch, getState);
        };
    }

    // startIm = async ({ auto_start }): Promise<void> => {
    //     // const { auto_start } = (await start()(dispatch, getState)) as PAYLOAD_START_SESSION;
    //     if (auto_start >= 0) {
    //         if (auto_start === 0) {
    //             IM.IMServer.loop();
    //         } else {
    //             setTimeout(async () => {
    //                 await selectgm()(dispatch, getState);
    //                 IM.IMServer.loop();
    //             }, auto_start);
    //         }
    //         IM.IMServer.iswakeup({ actived: 1, started: 1 });
    //     }
    // };

    saveContact = async (data: IM_SAVE_CONTACT): Promise<void> => {
        await saveContact(data)(dispatch, getState);
    };

    FaqInit = async (): Promise<void> => {
        const res = (await faqinit()(dispatch, getState)) as IM_USER_INFO;
        this._active();
        this._registerUserInfo(res);
        setloading(false)(dispatch, getState);
    };

    ImInit = async (isStart = false): Promise<void> => {
        try {
            setloading(true)(dispatch);
            const {
                base_config: { contact }
            } = getState().IndexReducer;
            const {
                contact: contacted,
                start: { auto_start },
                ...rest
            } = (await init(isStart)(dispatch, getState)) as ImState;
            if (!isStart) {
                this._active();
                this._registerUserInfo(rest);
            }
            if (_.isEmpty(contact) || contacted || isStart) {
                // await IM.InitServer.startIm(start);
                if (auto_start >= 0) {
                    if (auto_start === 0) {
                        IM.IMServer.loop();
                    } else {
                        setTimeout(async () => {
                            await selectgm()(dispatch, getState);
                            IM.IMServer.loop();
                        }, auto_start);
                    }
                    IM.IMServer.iswakeup({ actived: 1, started: 1 });
                }
            } else {
                IM.handlePopup({ popup: 'contact', open: true });
            }
        } catch (error) {
            if (error.c === 402) {
                // 防刷
                alert(error.e);
                IM.IMServer.iswakeup({ actived: 2 });
            }
        } finally {
            setloading(false)(dispatch, getState);
        }
    };

    stageTurn = (): boolean => {
        const { disabled_stage } = getState().FaqReducer;
        if (outline()) {
            return false;
        }
        // 阻止重复点击
        if (disabled_stage) {
            return false;
        }
        clickstage(true)(dispatch, getState);
        this.ImInit();
        return true;
    };

    InitChoice = async (): Promise<void> => {
        const {
            base_config: { faq_switch, session_in_service }
        } = getState().IndexReducer;
        if (session_in_service === 1) {
            await this.ImInit();
            return;
        }
        if (faq_switch === 1) {
            await this.FaqInit();
        } else {
            await this.ImInit();
        }
    };

    setup = async (): Promise<void> => {
        const {
            base_config: { tip, session_in_service }
        } = getState().IndexReducer;
        const { is_client } = IM.SDKServer.getState();

        // 注入分析sdk
        const script = document.createElement('script');
        script.src = 'https://jssdk.3304399.net/web-analytics-sdk_1.2.8.min.js';
        document.querySelectorAll('body')[0].appendChild(script);
        script.onload = () => {
            this.initWebAnalyticsSDK();
        };

        if (!is_client) {
            IM.IMServer.windowReload();
        }
        setloading(true)(dispatch);
        if (tip && !session_in_service) {
            IM.handlePopup({ popup: 'notice', open: true });
        }
        await this.InitChoice();
    };

    getFormToken = async ({ type, refer }): Promise<any> => {
        const token = await getformtoken({ type, refer })(dispatch, getState);
        return token;
    };

    initWebAnalyticsSDK = (): void => {
        window.webAanlytics2020?.initialize({
            mediaId: 'media-37225f20750742c4',
            appEnv: process.env.NODE_ENV,
            batchSend: false,
            auto: {
                click: false,
                stay: false
            }
        });
        // window.webAanlytics2020.setUid(gm_id);
        // window.webAanlytics2020.registerStatic({
        //     gm_nick: gm_name
        // });
    };
}
export default InitServer;
